import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'jquery/dist/jquery.min.js';

import "./custom.css"

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';

import Store from './store/AppStore'

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

/*
GA scripts 

import "https://www.googletagmanager.com/gtag/js?id=G-VVLEFCZE47"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-VVLEFCZE47');
</script>

/*

/*function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++) {
     var c = ca[i];
     while (c.charAt(0)==' ') c = c.substring(1);
     if(c.indexOf(name) == 0)
        return c.substring(name.length,c.length);
  }
  return "";
}

function checkForLoggedInCookie() {
  //let cookie = getCookie(".AspNetCore.Cookies");
  //console.log(cookie)
  console.log(document.cookie)
  let cookie = getCookie(".AspNetCore.Cookies");

  if (cookie == "") {
      return false;
  } 
  return true;
}*/

ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
        <App store={Store}/>
  </BrowserRouter>,
  rootElement);

// Uncomment the line above that imports the registerServiceWorker function
// and the line below to register the generated service worker.
// By default create-react-app includes a service worker to improve the
// performance of the application by caching static assets. This service
// worker can interfere with the Identity UI, so it is
// disabled by default when Identity is being used.
//
//registerServiceWorker();

